import React from "react";
import { Crown, Sparkles, Rocket } from "lucide-react";

const PLAN_META = {
  owner:      { label: "Verified Owner",   Icon: Crown,    cls: "bg-[#0F0F0F] text-[#FDFCF8]" },
  enterprise: { label: "Enterprise",       Icon: Crown,    cls: "bg-[var(--brand-primary)] text-white" },
  growth:     { label: "Growth · Verified", Icon: Rocket,  cls: "border border-[var(--brand-primary)] text-[var(--brand-primary)]" },
  starter:    { label: "Starter",          Icon: Sparkles, cls: "border border-[#0F0F0F] text-[#0F0F0F]" },
};

/**
 * Subtle trust signal showing what subscription tier the posting company is on.
 * Hidden for Free-tier posters (no badge keeps the listing clean).
 */
export default function PlanBadge({ plan, size = "sm" }) {
  const meta = PLAN_META[plan];
  if (!meta) return null;
  const { Icon, label, cls } = meta;
  const sizeCls = size === "md"
    ? "text-xs px-2 py-1 gap-1.5"
    : "text-[10px] tracking-widest px-1.5 py-0.5 gap-1";
  return (
    <span
      data-testid={`plan-badge-${plan}`}
      title={`Posted by a ${label} customer`}
      className={`inline-flex items-center font-semibold uppercase ${sizeCls} ${cls}`}
    >
      <Icon className={size === "md" ? "w-3.5 h-3.5" : "w-2.5 h-2.5"} /> {label}
    </span>
  );
}
